import { createContext } from 'react';

const TimeRangeContext = createContext();

export default TimeRangeContext;
